<div style="background-color: #dee4eb; min-height: 100vh; padding: 20px;">
  <div *ngIf="!cancellationSubmitted && !meetingLinkExpired" style="max-width: 600px; margin: 0 auto; background-color: #fff; border-radius: 8px; padding: 30px; box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);">
    <div style="display: flex; align-items: flex-start; margin-bottom: 20px;">
      <div style="margin-right: 20px;">
        <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="60" height="60" rx="4" fill="#FFF0F0" />
          <path d="M15 22H45V42C45 43.1046 44.1046 44 43 44H17C15.8954 44 15 43.1046 15 42V22Z" fill="#FFEEEE" />
          <path d="M17 16H43C44.1046 16 45 16.8954 45 18V22H15V18C15 16.8954 15.8954 16 17 16Z" fill="#FF6B6B" />
          <line x1="22" y1="13" x2="22" y2="19" stroke="#FF6B6B" stroke-width="2" stroke-linecap="round" />
          <line x1="38" y1="13" x2="38" y2="19" stroke="#FF6B6B" stroke-width="2" stroke-linecap="round" />
          <line x1="35" y1="35" x2="25" y2="25" stroke="#FF6B6B" stroke-width="2" stroke-linecap="round" />
          <line x1="25" y1="35" x2="35" y2="25" stroke="#FF6B6B" stroke-width="2" stroke-linecap="round" />
        </svg>
      </div>
      <div>
        <h1 style="font-size: 28px; margin: 0 0 10px 0; color: #333;">CANCEL MEETING</h1>
        <p style="font-size: 16px; color: #666; margin: 0;">
          The organizer of the meeting will be notified of the cancellation.
        </p>
      </div>
    </div>

    <div *ngIf="meetingDetails" style="border-top: 1px solid #eee; padding-top: 20px;">
      <div style="margin-bottom: 15px;">
        <div style="color: #666; font-size: 14px; margin-bottom: 5px;">Event name</div>
        <div style="font-size: 16px;">{{ meetingDetails.title || 'Meeting' }}</div>
      </div>

      <div style="margin-bottom: 15px;">
        <div style="color: #666; font-size: 14px; margin-bottom: 5px;">Date and time</div>
        <div style="font-size: 16px;">{{ formatMeetingDateTime() }}</div>
      </div>

      <div style="margin-bottom: 15px;">
        <div style="color: #666; font-size: 14px; margin-bottom: 5px;">Participants</div>
        <div style="font-size: 16px;">
          You and {{ meetingDetails.organizer?.name }} {{ meetingDetails.organizer?.lastName }}
          <span *ngIf="meetingDetails.organizer?.email">({{ meetingDetails.organizer?.email }})</span>
        </div>
      </div>

      <form [formGroup]="cancellationForm">
        <div style="margin-top: 30px;">
          <div style="color: #666; font-size: 14px; margin-bottom: 10px;">Message to invitee (optional)</div>
          <textarea 
            formControlName="message" 
            style="width: 100%; height: 100px; padding: 12px; border: 1px solid #ddd; border-radius: 4px; resize: vertical; font-family: inherit;"
            placeholder="Add a message..."></textarea>
        </div>


        <div style="margin-top: 30px; text-align: center;">
          <button 
            (click)="confirmCancellation()" 
            [disabled]="submitting"
            style="background-color: #4CAF50; color: white; border: none; padding: 12px 30px; font-size: 16px; border-radius: 4px; cursor: pointer; transition: background-color 0.3s;">
            {{ submitting ? 'Processing...' : 'Confirm cancellation' }}
          </button>
        </div>
      </form>
    </div>

    <div *ngIf="loading" style="text-align: center; padding: 20px;">
      <p>Loading meeting details...</p>
    </div>
  </div>

  <!-- Confirmation Screen -->
  <div *ngIf="cancellationSubmitted" style="max-width: 600px; margin: 0 auto; background-color: #fff; border-radius: 8px; padding: 30px; box-shadow: 0 0 10px rgba(0, 0, 0, 0.1); text-align: center;">
    <div style="margin-bottom: 20px;">
      <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="30" cy="30" r="30" fill="#4CAF50" />
        <path d="M20 30L27 37L40 24" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </div>
    <h1 style="font-size: 24px; margin-bottom: 20px;">Meeting Cancelled Successfully</h1>
    <p style="font-size: 16px; color: #666; margin-bottom: 30px;">
      The meeting has been cancelled and the organizer has been notified.
    </p>
  </div>

  <!-- Expired Link Screen -->
  <div *ngIf="meetingLinkExpired" style="max-width: 600px; margin: 0 auto; background-color: #fff; border-radius: 8px; padding: 30px; box-shadow: 0 0 10px rgba(0, 0, 0, 0.1); text-align: center;">
    <h2>Meeting link has expired or is invalid</h2>
    <p>Please contact the organizer for a new meeting link.</p>
  </div>

  <div style="text-align: center; margin-top: 20px; color: #666; font-size: 14px;">
    Schedule meetings quickly with <a href="https://dostifycrm.com">DostifyCRM</a>
  </div>
</div>